import React from 'react';
import PropTypes from 'prop-types';

import InputInlineEditable from "core/gd-components/input-inline-editable/input-inline-editable";
import SelectorInline from "core/gd-components/selector/inline/selector-inline";

export default class WorkdayDistributionOptions extends React.Component {

    static props = {
        value: PropTypes.object,

        inputRowClassName: PropTypes.string,

        disabled: PropTypes.bool,

        onSelect: PropTypes.func,
        onImmediateChange: PropTypes.func,
        onBlur: PropTypes.func,
    }

    onSelect = (value) => {
        if (this.props.onSelect) {
            this.props.onSelect(gd.utils.normalizeInt(parseInt(value), {min: 0, max: 10000}));
        } else {
            this.onImmediateChange(value);
            this.forceUpdate();
        }
    }

    onImmediateChange = (value) => {
        const normalizedValue = gd.utils.normalizeInt(parseInt(value), {min: 0, max: 10000});
        if (this.props.onImmediateChange) this.props.onImmediateChange(normalizedValue);
        else this.props.onSelect(normalizedValue);
    }

    render() {
        const workdayDistributionOption = (value) => ({
            id: value,
            label: '{0}%'.f(value)
        });

        const workdayDistributionOptions = [
            workdayDistributionOption(100),
            workdayDistributionOption(75),
            workdayDistributionOption(50),
            workdayDistributionOption(25),
        ];

        return (
            <React.Fragment>
                <div className={this.props.inputRowClassName}>
                    <InputInlineEditable className="gd-input small w-50"
                                         type="number"
                                         disabled={this.props.disabled}
                                         value={this.props.value}
                                         onBlur={this.props.onBlur}
                                         onImmediateChange={this.onImmediateChange}
                                         autoSaveChanges={false}
                                         autoSaveOnBlur={true}/>
                    <div className="ui5-txt-not-important-tiny m-l-10">%</div>
                </div>

                <SelectorInline className="selector-gray-bg s-26 m-t-10"
                                items={workdayDistributionOptions}
                                selectedId={this.props.value}
                                highlightSelected={false}
                                disabled={this.props.disabled}
                                onChange={this.onSelect} />
            </React.Fragment>
        )
    }
}